import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/api";
import { qk } from "@/lib/query-keys";
import { EMPTY_USER_PREFERENCES, type UserPreferences } from "@rivets/core";

/**
 * The account's saved agent/model/effort defaults, carried on the bootstrap
 * `/api/me` response every authenticated screen already loads. Returns the empty
 * preference set while that request is in flight, so callers can treat "not
 * loaded yet" and "nothing saved" identically — both mean "use worker defaults".
 */
export function useAgentDefaults(): UserPreferences {
  const { data } = useQuery({ queryKey: qk.me(), queryFn: () => client.me() });
  return data?.preferences ?? EMPTY_USER_PREFERENCES;
}
